import { render, staticRenderFns } from "./RentedProducts.vue?vue&type=template&id=2fd2c62c"
import script from "./RentedProducts.vue?vue&type=script&lang=js"
export * from "./RentedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports